<template>
  <COffcanvas class="app-panel" placement="end" :backdrop="true" :scroll="false" :visible="show"
    :aria-labelledby="labelId" @hide="$emit('close')">
    <div class="app-panel-head">
      <slot name="start" />
      <div class="app-panel-heading">
        <h2 :id="labelId" class="app-panel-title text-truncate">{{ title }}</h2>
        <div class="app-panel-subtitle text-truncate">{{ subtitle }}</div>
      </div>
      <CCloseButton class="flex-shrink-0" @click="$emit('close')" />
    </div>

    <COffcanvasBody v-if="$slots.default">
      <slot />
    </COffcanvasBody>

    <div v-if="$slots.actions" class="app-panel-actions">
      <slot name="actions" />
    </div>
  </COffcanvas>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/* The side panel of the device, account, customer and triage views. A view keeps its record
 * after closing the panel, so the content stays while the panel slides out. `labelId` differs
 * per view: the customer panel is on the page together with the others. */
export default defineComponent({
  name: 'AppPanel',
  props: {
    show: { type: Boolean, default: false },
    labelId: { type: String, required: true },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
  emits: ['close'],
})
</script>
